window.onload = function (){
	const $slider = document.querySelector('.js-swiper');
	const $contentText = document.querySelector('.js-content-text');
	const $contentStep = document.querySelector('.js-content-step');
	const $stickColl = document.querySelectorAll('.js-stick');
	const $prevButton = document.querySelector('.js-prev-slider');
	const $nextButton = document.querySelector('.js-next-slider');
	const $documentsSection = document.querySelector('.js-documents');
	const $anchorQuestion = document.querySelector('.js-anchor-question');
	const $innerDropdown = document.querySelector('.js-inner-dropdown-icon');
	const $innerDropdownContent = document.querySelector('.js-inner-content');
	const $innerDropdownSvg = document.querySelector('.js-inner-dropdown-svg');

	if(document.getElementById('premier_video')){
		document.getElementById('premier_video').addEventListener('click', function(){
			this.setAttribute("controls","controls");
			this.play();
		})
		document.getElementById('play_button').addEventListener('click', function (){
			document.getElementById('premier_video').setAttribute("controls","controls");
			document.getElementById('premier_video').play();
			this.style.display = 'none';
		})
	}
	const $Swiper = new Swiper($slider, {
		slidesPerView: 1.5,
		slidesPerGroup: 1,
		spaceBetween: 0,

		allowTouchMove: false,

		// pagination: {
		// 	el: '.swiper-pagination',
		// 	type: 'bullets',
		// },

		breakpoints: {
			300: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
			},
			480: {
				slidesPerView: 1.5,
				spaceBetween: 0,
			},
			768: {
				slidesPerView: 1.5,
			},
		},
	});


	//Логика для нижних кнопок

	const svgIcon = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="13" height="13" rx="3" fill="#138E28"/>
	<path d="M10.7899 3.11059C10.5545 2.57981 9.85661 2.45614 9.45314 2.87371L4.5 8L3.42122 6.91036C2.89905 6.38294 2 6.7527 2 7.49488C2 7.68575 2.06571 7.87079 2.18609 8.0189L3.8555 10.0729C4.24828 10.5561 4.98248 10.5667 5.38902 10.095L10.6617 3.97675C10.8683 3.73708 10.9182 3.39982 10.7899 3.11059Z" fill="white"/>
	</svg>`;

	const contentColl = [
		{
			step: '<strong>Шаг 1</strong>',
			text: 'На вкладке накопления в разделе <strong>«Инвестиции»</strong> выберете свой договор <strong>«Управляемый капитал»</strong>. Далее на открывшейся карточке нажмите на <strong>«Операции»</strong> и выберете <strong>«Внести средства»</strong>',
		},
		{
			step: '<strong>Шаг 2</strong>',
			text: 'Для внесения средств заполните:<br><ul class="right-step__list"><li>Карта списания</li><li>Сумма взноса (min 10 000 руб)</li><li>E-mail, куда будет направлено решение</li></ul>',
		},
		{
			step: '<strong>Шаг 3</strong>',
			text: `Проверьте документы. Если все корректно, подтвердите действие <img class="right-step__img-checkbox" src="/managed_capital_assets/img/checkbox.png">`,
		},
		{
			step: '<strong>Шаг 4</strong>',
			text: '<strong>В течение суток</strong> на указанный E-mail будет направлено решение.<br>Заявка обрабатывается <strong>до 2-х рабочих дней</strong>.',
		},
	];

	let stepCounter = 0;

	if($prevButton){
		$prevButton.addEventListener('click', () => {
			stepCounter -= 1;
			$contentStep.innerHTML = contentColl[stepCounter].step;
			$contentText.innerHTML = contentColl[stepCounter].text;
			$Swiper.slidePrev();
			setActiveSticks(stepCounter);

			if (stepCounter === 0) {
				$prevButton.classList.remove('active');
				$prevButton.classList.add('disable');
				return;
			}
			if (stepCounter === 1) {
				const $anchorButton = document.querySelector('.js-anchor');
				$anchorButton.addEventListener('click', () => {
					$anchorQuestion.click();
					$documentsSection.scrollIntoView({ behavior: 'smooth' });
				});
			}
			if (stepCounter < 3) {
				$nextButton.classList.add('active');
			}
		});
	}

	if($nextButton){
		$nextButton.addEventListener('click', () => {
			if (stepCounter === 4) {
				return;
			}
			stepCounter += 1;
			$contentStep.innerHTML = contentColl[stepCounter].step;
			$contentText.innerHTML = contentColl[stepCounter].text;
			$Swiper.slideNext();
			setActiveSticks(stepCounter);

			if (stepCounter >= 1) {
				$prevButton.classList.add('active');
			}

			if (stepCounter === 1) {
				const $anchorButton = document.querySelector('.js-anchor');
				$anchorButton.addEventListener('click', () => {
					$anchorQuestion.click();
					$documentsSection.scrollIntoView({ behavior: 'smooth' });
				});
			}

			if (stepCounter === 3) {
				if ($nextButton.classList.contains('active')) {
					$nextButton.classList.remove('active');
				}
				$nextButton.classList.add('disable');
			}
		});
	}

	//Логика для плашек

	$stickColl.forEach((elem) => {
		elem.addEventListener('click', () => {
			const index = elem.getAttribute('data-index');
			stepCounter = +index;
			$contentStep.innerHTML = contentColl[index].step;
			$contentText.innerHTML = contentColl[index].text;
			$Swiper.slideTo(index);

			setActiveSticks(+index);

			if (+index > 0) {
				$prevButton.classList.add('active');
			} else if (+index == 0) {
				$prevButton.classList.remove('active');
				$prevButton.classList.add('disable');
			}

			if (+index === 1) {
				const $anchorButton = document.querySelector('.js-anchor');
				$anchorButton.addEventListener('click', () => {
					$anchorQuestion.click();
					$documentsSection.scrollIntoView({ behavior: 'smooth' });
				});
			}

			if (+index === 3) {
				$nextButton.classList.add('disable');
			} else if (+index < 3) {
				$nextButton.classList.remove('disable');
				$nextButton.classList.add('active');
			}
		});
	});

	function setActiveSticks(elemIndex) {
		$stickColl.forEach((elem, index) => {
			if (index <= elemIndex) {
				if (elem.classList.contains('active')) {
					elem.classList.remove('active');
				}
				elem.classList.add('active');
			} else if (index > elemIndex) {
				if (elem.classList.contains('active')) {
					elem.classList.remove('active');
				}
			}
		});
	}

}
